import { gql } from "@apollo/client";
import { TypeDefinitionAttributeFields } from "../fragments/typeDefinitionAttribute";

export const CreateAssetTdas = gql`
    query CreateAssetTdas (
        $typeDefinitionIndex: AssetLocationTypeDefinitionIndex!,
        $options: AssetLocationTypeDefinitionAttributeListOptionsInput
    ) {
        assetLocationList {
            typeDefinitionAttributeList (typeDefinitionIndex: $typeDefinitionIndex, options: $options) {
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
